import React, { createContext, useContext, useState, useCallback } from 'react';
import client from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('sv360_token'));
  const [user, setUser] = useState(() => localStorage.getItem('sv360_user'));

  const login = useCallback(async (username, password) => {
    const res = await client.post('/api/auth/login', { username, password });
    const { token: t, user: u } = res.data;
    localStorage.setItem('sv360_token', t);
    localStorage.setItem('sv360_user', u);
    setToken(t);
    setUser(u);
    return true;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('sv360_token');
    localStorage.removeItem('sv360_user');
    setToken(null);
    setUser(null);
  }, []);

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider value={{ token, user, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
